/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../variables';

#HeaderBar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 100%;
  grid-template-areas: 'acronyms searchbar .';
  width: 100%;
  height: variables.$header-height;
  color: variables.$text-color-primary;
  padding: variables.$header-padding;
  align-items: center;
}
